<template>
  <v-dialog v-model="opened" persistent width="500">
    <v-window v-if="opened" class="elevation-1" vertical>
      <v-window-item>
        <ParticipantCustomPopup
          v-if="currentPopupQueueElement.modal === ParticipantModalType.CustomPopup"
          :custom-popup-content="currentPopupQueueElement.schedule.customPopupContent"
          :custom-popup-main-button-label="currentPopupQueueElement.schedule.customPopupMainButtonLabel"
          :custom-popup-secondary-button-label="currentPopupQueueElement.schedule.customPopupSecondaryButtonLabel"
          :custom-popup-title="currentPopupQueueElement.schedule.customPopupTitle"
          @continue="nextWindow"
        >
        </ParticipantCustomPopup>
        <ParticipantSelfie
          :currentStepName="currentPopupQueueElement.schedule ? currentPopupQueueElement.schedule.title : null"
          :customMessage="currentPopupQueueElement.schedule ? currentPopupQueueElement.schedule.selfieMessage : null"
          :customTitle="currentPopupQueueElement.schedule ? currentPopupQueueElement.schedule.selfieHeader : null"
          :endEventMode="endEventMode"
          @continue="nextWindow"
          v-if="currentPopupQueueElement.modal === ParticipantModalType.TakeASelfie"
          :runEnded="runEnded"
          @selfieUploaded="selfieUploaded"
        />
        <ParticipantGeolocation
          v-if="currentPopupQueueElement.modal === ParticipantModalType.RequestGeolocation"
          @continue="nextWindow"
        />
        <ParticipantChallengeCompleteConfirmation
          v-if="currentPopupQueueElement.modal === ParticipantModalType.ChallengeCompleteConfirmation"
          @continue="
            forceOpenChallengeCompleteConfirmationPopup = false;
            challengeCompleteConfirmationPopupClosed = true;
            clearScheduleCompleteConfirmationReopen();
            nextWindow();
          "
          @postpone="
            forceOpenChallengeCompleteConfirmationPopup = false;
            challengeCompleteConfirmationPopupClosed = true;
            scheduleCompleteConfirmationReopen();
            nextWindow();
          "
          @runEnded="
            forceOpenChallengeCompleteConfirmationPopup = false;
            challengeCompleteConfirmationPopupClosed = true;
            clearScheduleCompleteConfirmationReopen();
            runEndedClick();
          "
        ></ParticipantChallengeCompleteConfirmation>
        <ParticipantChallengePerformance
          :endEventMode="endEventMode"
          v-if="currentPopupQueueElement.modal === ParticipantModalType.ChallengePerformance"
          @continue="
            challengePerformancePopupClosed = true;
            forceOpenChallengeCompleteConfirmationPopup = false;
            challengeCompleteConfirmationPopupClosed = true;
            nextWindow();
          "
          @cancelPerformance="cancelPerformance"
        />
      </v-window-item>
    </v-window>
  </v-dialog>
</template>

<script>
import ParticipantSelfie from "./participant.selfie";
import ParticipantGeolocation from "./participant.geolocation";
import ParticipantChallengePerformance from "./participant.challenge_performance";
import ParticipantChallengeCompleteConfirmation from "./participant.challenge_complete_confirmation";
import ParticipantCustomPopup from "./participant.custom_popup";
import ParticipantModalType from "./model/participantModalType";

export default {
  name: "ParticipantPrepareChallengeModal",
  components: {
    ParticipantGeolocation,
    ParticipantSelfie,
    ParticipantChallengePerformance,
    ParticipantChallengeCompleteConfirmation,
    ParticipantCustomPopup,
  },
  props: {
    schedule: Object,
    runEnded: Boolean,
    runActivityScheduleEnded: Boolean,
    endEventMode: Boolean,
    endEventModes: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      opened: false,
      challengeCompleteConfirmationPopupClosed: false,
      forceOpenChallengeCompleteConfirmationPopup: false,
      challengeCompleteConfirmationPopupReopenIntervalId: null,
      challengePerformancePopupClosed: false,
      popupQueue: [],
      popupQueuePast: [],
      ParticipantModalType,
    };
  },
  methods: {
    nextWindow() {
      this.popupQueuePast.push(this.popupQueue.shift());
      if (this.popupQueue.length < 1) {
        this.opened = false;
        this.lastClosed();
      }
    },
    runEndedClick() {
      this.$emit("runEnded");
      this.nextWindow();
    },
    scheduleCompleteConfirmationReopen() {
      if (!this.challengeCompleteConfirmationPopupReopenIntervalId) {
        this.challengeCompleteConfirmationPopupReopenIntervalId = setInterval(() => {
          this.forceOpenChallengeCompleteConfirmationPopup = true;
        }, 10 * 1000 * 60);
      }
    },
    clearScheduleCompleteConfirmationReopen() {
      if (this.challengeCompleteConfirmationPopupReopenIntervalId)
        clearInterval(this.challengeCompleteConfirmationPopupReopenIntervalId);
    },
    selfieUploaded() {
      this.$emit("selfieUploaded");
    },
    lastClosed() {
      this.$emit("lastClosed");
    },
    getPopupQueueElement(schedule, modal) {
      return {
        id: schedule ? schedule.id : null,
        modal: modal,
        schedule: schedule,
      };
    },
    pushToPopupQueue(popupQueueElement) {
      this.popupQueue.push(popupQueueElement);
    },
    cancelPerformance() {
      this.challengePerformancePopupClosed = false;
      this.$emit("cancelPerformance");
    },
  },
  mounted() {
    this.opened = this.popupQueue.length > 0;
  },
  computed: {
    currentPopupQueueElement() {
      return this.popupQueue[0];
    },
    shouldShowChallengeCompleteConfirmation() {
      return (
        (this.runActivityScheduleEnded &&
          !this.$store.state.participantChallengeDeclared &&
          !this.challengeCompleteConfirmationPopupClosed) ||
        this.forceOpenChallengeCompleteConfirmationPopup
      );
    },
  },
  watch: {
    endEventModes: {
      handler: function (val) {
        if (val && val.length > 0) {
          val.forEach((modalType) => this.pushToPopupQueue(this.getPopupQueueElement(null, modalType)));
        }
      },
      immediate: true,
    },
    popupQueue(popupQueueValue) {
      this.opened = popupQueueValue.length > 0;
    },
    runEnded(runEndedValue) {
      if (runEndedValue && !this.challengePerformancePopupClosed) {
        this.pushToPopupQueue(this.getPopupQueueElement(null, ParticipantModalType.ChallengePerformance));
      }
    },
    shouldShowChallengeCompleteConfirmation(shouldShowConfirmation) {
      if (shouldShowConfirmation)
        this.pushToPopupQueue(this.getPopupQueueElement(null, ParticipantModalType.ChallengeCompleteConfirmation));
    },
    schedule: {
      handler: function (currentSchedule) {
        if (
          this.popupQueue.find((value) => value.id === currentSchedule.id) === undefined &&
          this.popupQueuePast.find((value) => value.id === currentSchedule.id) === undefined
        ) {
          if (currentSchedule.enableCustomPopup)
            this.pushToPopupQueue(this.getPopupQueueElement(currentSchedule, ParticipantModalType.CustomPopup));
          if (currentSchedule.enableTakeASelfie)
            this.pushToPopupQueue(this.getPopupQueueElement(currentSchedule, ParticipantModalType.TakeASelfie));
          if (currentSchedule.enableRequestGeolocation)
            this.pushToPopupQueue(this.getPopupQueueElement(currentSchedule, ParticipantModalType.RequestGeolocation));
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
